<template>
    <div v-if="!loading" class="pb-2">
        <b-card class="mb-2">
            <div class="d-flex align-items-center">
                <div @click="$router.push('/economic-info')" class="border-right pr-1 pointer">
                    <div class="text-center mb-50">
                        <feather-icon icon="ArrowRightIcon" size="26" />
                    </div>
                    <div style="font-size: 13px;">بازگشت</div>
                </div>
                <div class="px-1">
                    <div class="mb-50"> نام مجموعه : {{ details.storeName }}</div>
                    <div>
                        وضعیت :
                        <span :class="economicInfoVariant(details.status)">
                            {{ economicInfoStatus(details.status) }}
                        </span>
                    </div>
                </div>
            </div>
        </b-card>

        <b-card>
            <b-row>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        نوع شخص
                    </h5>
                    <h6>
                        {{ details.type == 0 ? 'حقیقی' : 'حقوقی' }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        نام
                    </h5>
                    <h6>
                        {{ details.firstName }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        نام خانوادگی
                    </h5>
                    <h6>
                        {{ details.lastName }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        شماره همراه
                    </h5>
                    <h6>
                        {{ details.phoneNumber }}
                    </h6>
                </b-col>
                <b-col v-if="details.type == 0" md="3" class="mb-2">
                    <h5 class="text-primary">
                        کد ملی
                    </h5>
                    <h6>
                        {{ details.nationalCode }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        نام پدر
                    </h5>
                    <h6>
                        {{ details.fatherName }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        تاریخ تولد
                    </h5>
                    <h6>
                        {{ new Date(details.birthDate).toLocaleDateString('fa-IR') }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        شماره شناسنامه
                    </h5>
                    <h6>
                        {{ details.birthCertificateNumber }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        سریال شناسنامه
                    </h5>
                    <h6>
                        {{ details.birthCertificateSeries }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        استان
                    </h5>
                    <h6>
                        {{ details.province.name }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        شهر
                    </h5>
                    <h6>
                        {{ details.city.name }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        تلفن ثابت
                    </h5>
                    <h6>
                        {{ details.landlinePhone }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        ایمیل
                    </h5>
                    <h6>
                        {{ details.email }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        نام بانک
                    </h5>
                    <h6>
                        {{ details.bank.name }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        شماره حساب
                    </h5>
                    <h6>
                        {{ details.cardNumber }}
                    </h6>
                </b-col>
                <b-col md="3" class="mb-2">
                    <h5 class="text-primary">
                        شماره شبا
                    </h5>
                    <h6>
                        {{ details.shabaNumber }}
                    </h6>
                </b-col>
                <b-col v-if="details.type == 1" md="3" class="mb-2">
                    <h5 class="text-primary">
                        شناسه ملی
                    </h5>
                    <h6>
                        {{ details.nationalId }}
                    </h6>
                </b-col>
                <b-col v-if="details.type == 1" md="3" class="mb-2">
                    <h5 class="text-primary">
                        شماره ثبت شرکت
                    </h5>
                    <h6>
                        {{ details.companyRegistrationNumber }}
                    </h6>
                </b-col>
                <b-col v-if="details.type == 1" md="3" class="mb-2">
                    <h5 class="text-primary">
                        تاریخ ثبت شرکت
                    </h5>
                    <h6>
                        {{ new Date(details.companyRegistrationDate).toLocaleDateString('fa-IR') }}
                    </h6>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-end mt-2">
                <b-button @click="economicInfoAccept" variant="primary" class="px-3" :disabled="details.status == 1">
                    تایید
                </b-button>
            </div>
        </b-card>
        <b-card>
            <b-form-textarea v-model="form.reason" placeholder="دلیل رد" dir="rtl" class="text-primary-middle"
                :disabled="details.status == 1" />
            <div class="d-flex justify-content-end mt-2">
                <b-button @click="economicInfoReject" variant="danger" class="px-3" :disabled="details.status == 1">
                    رد
                </b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BCardText, BRow, BCol, BButton, BFormTextarea } from 'bootstrap-vue';
import { adminService } from '@core/services';
import { default as locations } from '@/@core/data/provinces';

export default {
    components: {
        BCard,
        BCardText,
        BRow,
        BCol,
        BButton,
        BFormTextarea,
    },
    data() {
        return {
            provinces: [...locations],
            loading: true,
            storeId: null,
            details: {},
            form: {
                reason: null,
            },
            loadingButton: false,
        };
    },
    computed: {
        economicInfoStatus() {
            return (status) => {
                if (status == 0) {
                    return 'بررسی نشده'
                }
                if (status == 1) {
                    return 'تایید شده'
                }
                if (status == 2) {
                    return 'رد شده'
                }
            }
        },
        economicInfoVariant() {
            return (status) => {
                if (status == 0) {
                    return 'text-primary'
                }
                if (status == 1) {
                    return 'text-success'
                }
                if (status == 2) {
                    return 'text-danger'
                }
            }
        },
    },
    methods: {
        getEconomicInfoDetails() {
            adminService.economicInfoDetails(this.storeId).then(({ data }) => {
                this.details = data;
                this.form.reason = this.details.rejectionReason
                this.loading = false;
            })
        },
        economicInfoReject() {
            adminService.economicInfoReject(this.storeId, this.form).then(({ data }) => {
                this.$notif({ type: 'success' });
                this.$router.push('/economic-info')
            })
        },
        economicInfoAccept() {
            adminService.economicInfoAccept(this.storeId).then(({ data }) => {
                this.$notif({ type: 'success' });
                this.$router.push('/economic-info')
            })
        }
    },
    mounted() {
        this.storeId = this.$route.query.id ? this.$route.query.id : 0;
        this.getEconomicInfoDetails()
    },
};
</script>
